export default __webpack_public_path__ + "static/media/correct-measure.e67ced28.svg";